module.exports = __webpack_public_path__ + "static/media/watermelon-pack-illustration-18.606d8d43.svg";